import { Injectable } from '@angular/core';
import { NbToastrService } from '@nebular/theme';
import { AmplifyApiService } from 'src/app/core/services/amplify-api.service';
import { CleaningTimeEstimate } from 'src/app/models/qa-models/cleaning-time-estimate';
import { APIS } from 'src/app/shared/constants/api-constants';
import { ENVIRONMENT } from 'src/environments/environment';

@Injectable({ providedIn: 'any' })
export class CleaningTimeEstimateService {
  public cleaning_estimates_api = APIS.CLEANING_ESTIMATES;

  constructor(
    private toastrService: NbToastrService,
    private apiService: AmplifyApiService
  ) {}

  public loadCleaningTimeEstimate(robot_id: string): Promise<CleaningTimeEstimate[] | CleaningTimeEstimate | null> {
    return this.apiService
      .get(
        this.cleaning_estimates_api,
        `/${ENVIRONMENT.apiHkcInsightsName}/insights/qa/cleaning-estimates/${robot_id}`,
        {}
      )
      .then((response: any) => {
        if (!response) {
          this.toastrService.show($localize`No Cleaning time estimate found for ${robot_id}`, { status: 'danger' });
          return null;
        } else {
          return response;
        }
      })
      .catch((error) => {
        console.error(error);
        this.toastrService.show('', $localize`Fetching cleaning time estimate failed`, { status: 'danger' });
        return null;
      });
  }

  public stripUiOnlyFields(estimate: CleaningTimeEstimate): CleaningTimeEstimate {
    return {
      ...estimate,
      cleaning_time_estimates: estimate.cleaning_time_estimates.map(({ display: _display, ...area }) => area)
    };
  }

  public updateCleaningTimeEstimates(robot_id: string, estimates: CleaningTimeEstimate[]): Promise<boolean> {
    const body = estimates.map((e) => this.stripUiOnlyFields(e));
    return this.apiService
      .put(
        this.cleaning_estimates_api,
        `/${ENVIRONMENT.apiHkcInsightsName}/insights/qa/cleaning-estimates/${robot_id}`,
        { body }
      )
      .then(() => {
        this.toastrService.show('', $localize`Cleaning time estimates saved`, { status: 'success' });
        return true;
      })
      .catch((error) => {
        console.error(error);
        this.toastrService.show('', $localize`Failed to save cleaning time estimates`, { status: 'danger' });
        return false;
      });
  }
}
